<div class="policy-category bus-lane">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <div class="default-text" [innerHTML]="textCopy.firstTitle"></div>
    <div *ngFor="let question of firstRadioQuestions">
      <radio-question [data]="question.data" [active]="question.active"
                      [valueSelected]="question.valueSelected"
                      (selectAnswer)="onFirstRadioQuestionsSelect($event, question.id)"></radio-question>
    </div>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <div class="default-text large" [innerHTML]="textCopy.secondTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.secondSubTitle"></div>
    <div>
      <span class="select-layer inline">
        <select class="app-select"
                (change)="onBusLaneSelectionChange($event.target.value)">
          <option value="0" selected disabled hidden>please select...</option>
          <option value="1">new bus lane</option>
          <option [value]="busLane.id" *ngFor="let busLane of busLaneList">
            {{busLane.name}}
          </option>
        </select>
      </span>
      <a (click)="deleteBusLane()" class="delete-text-inline"
         [ngClass]="{'disabled': !isBusLaneSelected()}">
        delete
    </a>
    </div>
    <div class="default-text" [innerHTML]="textCopy.secontBusLaneName"></div>
    <input aria-label=""  type="text" class="app-input" [(ngModel)]="selectedBusLane.name"
           [disabled]="isBusLaneDisabled()" />
    <br />
    <div class="default-text" [innerHTML]="textCopy.secontBusLaneDescription"></div>
    <textarea class="app-textarea" [(ngModel)]="selectedBusLane.description"
              [maxlength]="busLaneDescriptionMaxLength"
              [disabled]="isBusLaneDisabled()"></textarea>
    <div class="default-text">
      {{selectedBusLane.description.length}} / {{busLaneDescriptionMaxLength}} characters
    </div>
    <br />
    <div class="default-text" [innerHTML]="textCopy.secontBusLaneType"></div>
    <span class="select-layer inline" [ngClass]="{'disabled': isBusLaneDisabled()}">
      <select class="app-select" (change)="selectedBusLane.selectedTypeId = $event.target.value"
              [disabled]="isBusLaneDisabled()">
        <option value="0" [selected]="selectedBusLane.selectedTypeId === '0' || !isBusLaneSelected()">Bus lane</option>
        <option value="1" [selected]="selectedBusLane.selectedTypeId === '1'">Bus gate</option>
        <option value="2" [selected]="selectedBusLane.selectedTypeId === '2'">Tram gate</option>
      </select>
    </span>
    <br />
    <div class="default-text" [innerHTML]="textCopy.secontBusLaneLocation"></div>
    <input aria-label=""  type="text" class="app-input" [(ngModel)]="selectedBusLane.location"
           [disabled]="isBusLaneDisabled()" />
    <div class="label info" [ngClass]="busLaneSuccess ? 'green' : 'red'"
         *ngIf="busLaneMessage.length > 0">
      {{busLaneMessage}}
    </div>
    <br/>
    <a (click)="addBusLane()" class="delete-text-inline" *ngIf="selectedBusLane.id === '1' && selectedBusLane.name.length > 0">
      add
      <br />
    </a>
    <a (click)="updateBusLane()" class="delete-text-inline" *ngIf="selectedBusLane.id !== '0' && selectedBusLane.id !== '1' && selectedBusLane.name.length > 0">
      update
      <br />
    </a>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <radio-question [data]="thirdRadioQuestion.data" [active]="thirdRadioQuestion.active"
                    [valueSelected]="thirdRadioQuestion.valueSelected"
                    (selectAnswer)="onThirdRadioQuestionSelect($event)"></radio-question>
    <br />
    <div class="default-text" [innerHTML]="textCopy.thirdParagraphOne"></div>
    <br />
    <div class="default-text">
      {{textCopy.busLaneCancelText}}
      <input aria-label=""  class="app-input" type="text" [(ngModel)]="busLaneCancel"
             [disabled]="thirdRadioQuestion.valueSelected === 'n'" />
      .
    </div>
    <br />
    <div class="default-text" [innerHTML]="textCopy.thirdParagraphTwo"></div>
    <div class="default-text">
      {{textCopy.beforeBusLaneNotice}}
      <input aria-label=""  class="app-input" type="text" [(ngModel)]="busLaneNotice"
             [disabled]="thirdRadioQuestion.valueSelected === 'n'" />
      {{textCopy.afterBusLaneNotice}}
    </div>
    <br />
  </div>

  <div class="policy-item">
    <i class="policy-number">4</i>
    <radio-question [data]="fourthRadioQuestion.data" [active]="fourthRadioQuestion.active"
                    [valueSelected]="fourthRadioQuestion.valueSelected"
                    (selectAnswer)="onFourthRadioQuestionSelect($event)">
    </radio-question>

  </div>


  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
